<template>
  <div type="dark" class="navi" variant="default" sticky>
    <button class="toggle-sidebar d-lg-none" @click="toggleSidebar">
      <b-icon-list variant="light"></b-icon-list>
    </button>
    <router-link to="/" class="navi__brand mr-auto ml-3 ml-lg-0" target="_self">
      <template v-if="siteParams">
        {{ siteParams.siteName }}
      </template>
    </router-link>
    <nav class="navi__list ml-auto">
      <li class="navi__list-item d-none d-md-block">
        <router-link exact v-if="isHome === false" to="/">
          Главная
        </router-link>
      </li>
      <li class="navi__list-item">
        <a href="/" v-if="isHome" v-scroll-to="{ el: '#begin', offset: -35 }">
          Как начать?
        </a>
      </li>
      <li class="navi__list-item">
        <a href="/" v-if="isHome" v-scroll-to="{ el: '#tests', offset: -35 }">
          Тесты
        </a>
      </li>
      <li class="navi__list-item d-none d-md-block">
        <router-link to="/students">Студентам</router-link>
      </li>
      <li class="navi__list-item d-none d-md-block">
        <router-link to="/about">О нас</router-link>
      </li>
      <li class="navi__list-item" v-if="!isLoggedIn">
        <router-link to="/login">
          <svg class="icon">
            <use xlink:href="@/assets/img/icons/nav-icons.svg#login" />
          </svg>
          Вход
        </router-link>
      </li>
      <li class="navi__list-item" v-if="!isLoggedIn">
        <router-link to="/register">
          <svg class="icon">
            <use xlink:href="@/assets/img/icons/nav-icons.svg#sign-up" />
          </svg>
          Регистрация
        </router-link>
      </li>
      <b-nav-item-dropdown
        right
        no-caret
        v-if="isLoggedIn"
        class="e-logged-in-dropdown-item"
      >
        <template #button-content>
          <b-avatar variant="info" size="2em"></b-avatar>
        </template>
        <b-dropdown-item to="/dashboard">Личный кабинет</b-dropdown-item>
        <b-dropdown-item @click.prevent="logout">Выход</b-dropdown-item>
      </b-nav-item-dropdown>
    </nav>
    <!-- </b-collapse> -->
  </div>
</template>

<script>
import { BIconList } from 'bootstrap-vue';

export default {
  components: {
    BIconList
  },
  computed: {
    isHome() {
      return this.$route.name === 'Home';
    },
    isDashboard() {
      return this.$route.name === 'Dashboard';
    },
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    sidebarState() {
      return this.$store.getters.sidebarOpened;
    },
    siteParams() {
      return this.$store.getters.getSiteParams;
    }
  },
  methods: {
    toggleSidebar() {
      this.$store.commit('setSidebarState', !this.sidebarState);
    },
    async logout() {
      try {
        await this.$store.dispatch('logout');
        this.$router.push('/');
      } catch (e) {
        //
      }
    }
  }
};
</script>

<style lang="scss">
.e-logged-in-dropdown-item {
  .dropdown-menu {
    border: 0;
    box-shadow: 0px 16px 16px rgba(50, 50, 71, 0.08),
      0px 24px 32px rgba(50, 50, 71, 0.08);
  }
}
</style>
